// Slug-only mirror of coffee_shop.jsx/gyms.jsx/hospitals.jsx/lobby.jsx, for
// consumers (the homepage use-case grid) that only need to build a link and
// would otherwise pull in each solution's full page content (~35KB+ each of
// copy/FAQ/translations) just to read one field. Keep these in sync with the
// corresponding solution file's `slug` object if either ever changes.
export const coffee_shop_slug = {
  en: "digital-signage-for-restaurants",
  de: "digital-signage-fuer-restaurants",
  es: "senalizacion-digital-para-restaurantes",
  fr: "affichage-dynamique-pour-restaurants",
  it: "digital-signage-per-ristoranti",
  pt: "digital-signage-para-restaurantes",
  sr: "digitalni-signage-za-restorane",
};

export const gyms_slug = {
  en: "digital-signage-for-gyms",
  de: "digital-signage-fuer-fitnessstudios",
  es: "senalizacion-digital-para-gimnasios",
  fr: "affichage-dynamique-pour-salles-de-sport",
  it: "digital-signage-per-palestre",
  pt: "digital-signage-para-academias",
  sr: "digitalni-signage-za-teretane",
};

export const hospitals_slug = {
  en: "digital-signage-for-healthcare",
  de: "digital-signage-fuer-gesundheitswesen",
  es: "senalizacion-digital-para-sanidad",
  fr: "affichage-dynamique-pour-sante",
  it: "digital-signage-per-sanita",
  pt: "digital-signage-para-saude",
  sr: "digitalni-signage-za-zdravstvo",
};

export const lobby_slug = {
  en: "digital-signage-for-lobbies",
  de: "digital-signage-fuer-empfangsbereiche",
  es: "senalizacion-digital-para-vestibulos",
  fr: "affichage-dynamique-pour-halls",
  it: "digital-signage-per-hall",
  pt: "digital-signage-para-recepcoes",
  sr: "digitalni-signage-za-holove",
};
